module.exports = __webpack_public_path__ + "img/video-9-bg.62fdf156.jpg";